import {useTranslation} from 'react-i18next';
import CustomModal from '../../Modal/CustomModal';
import React from 'react';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param boolean show: open to modal
 * @param model typeSuggestions: required if showBtnCamera == true, the model must come from SUGGESTION_MODE_OPTION
 * @param event onHide: event to close modal
 * @param event onConfirm: event to confirm modal
 *
 */
const CustomModalSuggestions = ({ show, typeSuggestions, onHide, onConfirm}) => {
    const { t } = useTranslation();

    return (
        <CustomModal
            closeButton={false}
            title={typeSuggestions?.TITLE ? t(typeSuggestions.TITLE) : ''}
            size={typeSuggestions?.SIZE || 'xs'}
            cancelButton={false}
            confirmButton={true}
            show={show}
            onHide={() => {
                onHide()
            }}
            onConfirm={()=>{
                onConfirm();
            }}
            classNameBody="pt-2"
        >
            { typeSuggestions?.CONTENT &&
            <>
                {typeSuggestions.CONTENT}
            </>
            }

        </CustomModal>
    );
};

export default CustomModalSuggestions;
